import React, { Component } from "react";

class NotFound extends Component {
    state = {};

    constructor(props: Map<any, any>) {
        super(props);
    }

    render() {
        return <div>NotFound Component</div>;
    }
}

export default NotFound;
